/* globals angular, _ */
(function(){
  'use strict';

  function FilterTableGlobalCtrl (localStorageService) {
    var ctrl = this;
    ctrl.filterFirstLevel = {};
    ctrl.clear = function (evt) {
      ctrl.filter.text.options.isText = null;
      ctrl.filterFirstLevel.$setPristine();
      ctrl.clearFilter({ $event: evt });
    };
    var keyMap = [
      {
        name: 'cep',
        eventName: 'filterCEP',
      },
      {
        name: 'rastreamento',
        eventName: 'filterTrackid',
      },
      {
        name: 'nomeDestinatario',
        eventName: 'filterName',
      },
      {
        name: 'documentoDestinatario',
        eventName: 'FilterDocument',
      },
      {
        name: 'referencia',
        eventName: 'FilterOrder',
      },
    ];
    function _trackEvent (config) {
    }
    ctrl.send = function () {
      if (ctrl.filterFirstLevel.$invalid) { return; }
      var key = ctrl.filter.select.isSelected.name;
      var value = ctrl.filter.text.options.isText;
      var searchObj = {};
      searchObj[key] = value;
      var event = _.find(keyMap, {name: key});
      var config = {
        type: 'issues',
        email: localStorageService.get('user').email,
        action: 'filter',
        actionName: event ? event.eventName : null,
        actionValue: value,
      };
      _trackEvent(config);
      ctrl.updateFilter({ $event: searchObj });
    };
  }

  angular
    .module('mandaeApp')
    .controller('FilterTableGlobalCtrl', FilterTableGlobalCtrl);
}());
